import { get, round } from 'lodash-es';
/* Utils */
import { EventToolbox } from 'client/utils/event-toolbox';
import {
  getAdditionalTrackingData,
  getInventoryTrackingData,
} from 'site-modules/shared/utils/price-checker/community-share-utils';
/* Constants */
import {
  PRICE_CHECKER_EVENTS,
  PRICE_CHECKER_CROWDSOURCING_CREATIVE_ID,
} from 'client/site-modules/shared/constants/price-checker';
import { TrackingConstant } from 'client/tracking/constant';

export function fireSelectDealerTracking({ detail: { dealer } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_TOOL_SELECT,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      subaction_name: TrackingConstant.SUBACTION_DEALER_SELECT,
      creative_id: PRICE_CHECKER_CROWDSOURCING_CREATIVE_ID,
      value: dealer,
    },
  });
}

export function fireListViewTracking({ detail: { vehicle, prices, ratedDealType, selectedDealer, additionalData } }) {
  const { userDealerPrice, userMsrp } = prices;
  let belowMarket = round((userMsrp - userDealerPrice) / userMsrp, 4);
  if (!isFinite(belowMarket)) belowMarket = '';

  EventToolbox.fireTrackAction({
    ...getAdditionalTrackingData({ ...additionalData, style: get(vehicle, 'style') }),
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_LIST,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      creative_id: PRICE_CHECKER_CROWDSOURCING_CREATIVE_ID,
      loc_id_list: `${get(selectedDealer, 'rooftopId', '')}`,
      f_id_list: `${get(selectedDealer, 'id', '')}`,
      ...getInventoryTrackingData(vehicle),
      price: userMsrp,
      recommended_offer: userDealerPrice,
      below_market: belowMarket,
      deal_indicator: ratedDealType,
      subaction_name: TrackingConstant.DEAL_SHARED,
      ts: Date.now(),
    },
  });
}

export function fireSubmitTracking({ detail: { subactionName } }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_name: TrackingConstant.ACTION_TOOL_SELECT,
      action_cause: TrackingConstant.SYSTEM_ACTION_CAUSE,
      action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
      subaction_name: subactionName,
      creative_id: PRICE_CHECKER_CROWDSOURCING_CREATIVE_ID,
    },
  });
}

export const PriceCheckerEngagementHandler = {
  init: () => {
    EventToolbox.on(PRICE_CHECKER_EVENTS.SELECT_DEALER, fireSelectDealerTracking);
    EventToolbox.on(PRICE_CHECKER_EVENTS.LIST_VIEW, fireListViewTracking);
    EventToolbox.on(PRICE_CHECKER_EVENTS.SUBMIT, fireSubmitTracking);
  },
};
